











import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/header/Header.vue';
import Footer from '@/components/Footer.vue';
import CookieBanner from '@/components/general/CookieBanner.vue';

@Component({
  components: {
    CookieBanner,
    Footer,
    Header,
  },
})
export default class Root extends Vue {}
